// extracted by mini-css-extract-plugin
export default {"container":"request_footer_container__eEMuF"};